






















































import { index, destroy, approved } from '@/api/original_dramas'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  screening: Record<string, any> = {
    status: 0
  }

  config: Record<string, any> = {
    api: index,
    include: 'brand',
    paginate: true,
    fields: [
      { prop: 'id', label: '#', width: 60 },
      { prop: 'thumbnail', label: 'T', slot: true, width: 100 },
      { prop: 'overview', label: 'Overview', slot: true },
      { prop: 'status', label: 'Status', width: 100, slot: true },
      { prop: 'dramas_count', label: 'Dramas Count', width: 150 },
      { prop: 'duration', label: 'Duration', width: 120 },
      { prop: 'difficulty_zh', label: 'Difficulty', width: 120 },
      { prop: 'differences', label: 'Differences', slot: true, width: 120 },
      { prop: 'created_at', label: 'Created time', width: 150 }
    ]
  }

  async destroyRow (row: Record<string, any>) {
    this.$ask(async () => {
      await destroy(row.id)
      const el: any = this.$refs.table
      el.getItems(1)
      this.$message.success('Data has been deleted')
    })
  }

  async approvedRow (row: Record<string, any>) {
    await approved(row.id)
    const el: any = this.$refs.table
    el.getItems(1)
    this.$message.success('Data has been Approved')
  }
}
